import React, { ComponentType } from 'react';
import { Typography, TypographyProps } from '@cp/ds/src/components/typography';
import { ActionButton } from '@cp/ds/src/components/actionButton';
import { CopyIcon } from '@cp/ds/src/icons';
import { styled } from '@cp/ds/src/theme';
import { cssToken } from '@youhelp-ru/ui';
import { copyTextToClipboard } from './clipboard';

export interface CopyableTextProps extends Omit<TypographyProps, 'children'> {
  children: string | undefined;
  onCopied?: () => void;
}

const COPY_TEXT = 'Копировать';
const COPIED_TEXT = 'Скопировано!';

const name = 'CopyableText';
export const CopyableTextTokens = {
  ButtonPadding: cssToken(name, ['dimension', 'button', 'padding']),
};
const Root = styled(Typography, { name })({
  whiteSpace: 'nowrap',
  display: 'inline-flex',
  alignItems: 'center',
}) as unknown as ComponentType<TypographyProps>;

export const CopyableText: React.FC<CopyableTextProps> = ({ children, onCopied, ...props }) => {
  const [hint, setHint] = React.useState(COPY_TEXT);
  const doCopy: React.PointerEventHandler<HTMLButtonElement> = React.useCallback(
    (e) => {
      e.preventDefault();
      if (children) {
        copyTextToClipboard(children);
        setHint(COPIED_TEXT);
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        setTimeout(() => setHint(COPY_TEXT), 2000);
        onCopied?.();
      }
    },
    [children, onCopied],
  );

  return (
    <Root {...props}>
      {children}
      {Boolean(children) && (
        <ActionButton hint={hint} onClick={doCopy} sx={{ padding: CopyableTextTokens.ButtonPadding('8px') }}>
          <CopyIcon />
        </ActionButton>
      )}
    </Root>
  );
};
